import { MontelAccount } from 'domain/account/interfaces/MontelAccount';
import { Subscription } from 'domain/subscription/interfaces/Subscription';
import { Text } from '@montel/montelpro-shared-components-v2';

export const SubscriptionsNotice: React.FC<{
	account: MontelAccount;
	subscriptions?: Subscription[];
}> = ({ account, subscriptions }) => {
	if (!subscriptions || subscriptions.length === 0) return null;

	const subscriptionsInCurrentCompany = subscriptions.filter(
		(s) => s.companyId === account.company.id,
	);

	if (!subscriptionsInCurrentCompany.length) {
		return null;
	}

	if (subscriptionsInCurrentCompany.length === 1) {
		return (
			<Text align="center" fontStyle="italic">
				Please note: The user has a seat in a subscription belonging to{' '}
				{account.company.name}. Take action as required if you reassign
				the user to a different company.
			</Text>
		);
	}

	return (
		<Text align="center" fontStyle="italic">
			Please note: The user has {subscriptionsInCurrentCompany.length}{' '}
			seats in subscriptions belonging to {account.company.name}. Take
			action as required if you reassign the user to a different company.
		</Text>
	);
};
